import * as T from './PageMeta.types';

export const defaultMeta: Required<T.MetaProps> = {
  title:
    'Российское общество Знание – проведение мероприятий, гранты, лекции, марафоны',
  description:
    'Открытые уроки, лекции, мастер-классы, дебаты, свободные обсуждения самых актуальных и важных тем современности',
  image: '/img/share/default.jpeg',
  canonicalHref: 'https://znanierussia.ru',
  disableIndexing: false,
};

export const metaMap: T.MetaMap = {
  '/about': {
    title:
      'Информация об общественной некоммерческой организации «Российское общество «Знание»',
    description:
      'Общественная некоммерческая организация «Российское общество «Знание» осуществляет просветительскую работу в 88 субъектах Российской Федерации',
    canonicalHref: 'https://znanierussia.ru/about',
  },
  '/about/accreditation': {
    title:
      'Российское общество «Знание» - Государственная аккредитация программ ВО и СПО',
    description:
      'Экспертная организация Российское общество Знание в государственной аккредитации программ высшего образования и среднего профессионального образования',
    canonicalHref: 'https://znanierussia.ru/about/accreditation',
  },
  '/about/contacts': {
    title: 'Контакты Российского общества «Знание»',
    description:
      'Контактная информация «Российского общества «Знание»: электронная почта, телефон, адрес, реквизиты',
    canonicalHref: 'https://znanierussia.ru/about/contacts',
  },
  '/about/departments': {
    title: 'Региональные отделения Российского общества «Знание»',
    description:
      'Региональные отделения и представительства «Российского общества «Знание» во всех округах',
    canonicalHref: 'https://znanierussia.ru/about/departments',
  },
  '/about/documents': {
    title:
      'Документы Российского общества «Знание» – документация по грантам, деятельности, основные документы',
    description:
      'Полная документация «Российского общества «Знание»: описание целей и задач, документы по грантам, победителям конкурсов',
    canonicalHref: 'https://znanierussia.ru/about/documents',
  },
  '/about/history': {
    title: 'История Российского общества «Знание»',
    description: 'История и хронология «Российского общества «Знание»',
    canonicalHref: 'https://znanierussia.ru/about/history',
  },
  '/about/partners': {
    title: 'Партнеры и спонсоры «Российского общества «Знание»',
    description:
      'Партнеры Российского общества «Знание» – ключевые партнеры по развитию общества «Знание», Сириус, Росмолодежь, Сбер, VK, ВК, Российское военно-историческое общество, РВИО,  ВШЭ, Высшая школа экономики, Росконгресс, Россия – страна возможностей, Министерство науки и высшего образования Российской Федерации, Минобр науки, Российский союз боевых искусств, РСБИ, Российская академия наук, РЖД, Российские железные дороги, Санкт-Петербургский государственный университет, СПбГУ, Росатом, Большая перемена, Политех, Санкт-Петербургский политехнический университет Петра Великого, Министерство просвещения Российской Федерации, Минпросвещения России, Московский финансово-промышленный университет «Синергия», «Россия – моя история», ГТО, Готов к труду и обороне, МФТИ, Московский физико-технический институт, Твой Ход, Авангард, Национальная ассоциация заслуженных врачей и наставников',
    canonicalHref: 'https://znanierussia.ru/about/partners',
  },
  '/about/university': {
    title: 'Сетевой Университет «Знание»',
    description:
      'Сетевой Университет «Знание», лицензия на осуществление образовательной деятельности, Сведения об автономной некоммерческой  организации дополнительного профессионального образования, дополнительное образование, сведения об учредителе, документы, дополнительные профессиональные программы повышения квалификаций, повышение квалификации',
    canonicalHref: 'https://znanierussia.ru/about/university',
  },
  '/events': {
    title: 'Календарь мероприятий Российского общества Знание',
    description:
      'Календарь мероприятий: открытые уроки, лекции, мастер-классы, дебаты, свободные обсуждения самых актуальных и важных тем современности на 2021-2022 год',
    canonicalHref: 'https://znanierussia.ru/events',
  },
  '/library': {
    title: 'Лекции Российского общества «Знание»',
    description:
      'Лекции Российского общества Знание, полезные материалы, открытые уроки, интервью с известными людьми и записи мероприятий от Российского общества Знание',
    canonicalHref: 'https://znanierussia.ru/library',
  },
  '/library/intervyu-88': {
    title: 'Интервью с известными людьми от Российского общества «Знание»',
    description:
      'Интервью с политиками, лекторами, артистами, учёными от Российского общества Знание',
    canonicalHref: 'https://znanierussia.ru/library/intervyu-88',
  },
  '/library/lekciya-89': {
    title: 'Записи лекций Российского общества «Знание»',
    description:
      'Записи лекций обо всём нас свете с участием лекторов Российского общества Знание',
    canonicalHref: 'https://znanierussia.ru/library/lekciya-89',
  },
  '/library/diskussiya-90': {
    title: 'Дискуссии с лекторами Российского общества «Знание»',
    description:
      'Дискуссии на разные темы с участием лекторов Российского общества Знание',
    canonicalHref: 'https://znanierussia.ru/library/diskussiya-90',
  },
  '/library/master-klass-91': {
    title: 'Мастер-классы от лекторов Российского общества «Знание»',
    description:
      'Мастер-классы для совершенствования разных навыков с участием лекторов Российского общества Знание',
    canonicalHref: 'https://znanierussia.ru/library/master-klass-91',
  },
  '/library/otkrytyj-urok-111': {
    title: 'Открытые уроки с участием лекторов Российского общества «Знание»',
    description:
      'Открытые уроки на разные темы, проведённые лекторами Российского общества Знание',
    canonicalHref: 'https://znanierussia.ru/library/otkrytyj-urok-111',
  },
  '/library/foto-videootchyot-s-iventa-107': {
    title: 'Записи мероприятий Российского общества «Знание»',
    description:
      'Записи мероприятий, проведенные Российским обществом «Знание»: Премия «Знание» и другие',
    canonicalHref:
      'https://znanierussia.ru/library/foto-videootchyot-s-iventa-107',
  },
  '/management': {
    title: 'Руководство Российского общества «Знание»',
    description:
      'Руководство, руководство Российского общества «Знание», Древаль, Рыбальченко, Колесников, Воронин, Майоров, Нырова, Координационный совет, Наблюдательный совет, Заседания совета',
    canonicalHref: 'https://znanierussia.ru/management',
  },
  '/management/coordination-council': {
    title: 'Координационный совет Российского общества «Знание»',
    description:
      'Координационный совет Российского общества «Знание», Глебова, Зинченко, Мау и Члены совета',
    canonicalHref: 'https://znanierussia.ru/management/coordination-council',
  },
  '/management/supervisory-council': {
    title: 'Наблюдательный совет Российского общества «Знание»',
    description:
      'Наблюдательный совет Российского общества «Знание», Кириенко, Мединский, Орешкин, Фурсенко, Духанина',
    canonicalHref: 'https://znanierussia.ru/management/supervisory-council',
  },
  '/management/council-meetings': {
    title: 'Заседания совета Российского общества «Знание»',
    description:
      'Заседания Российского общества «Знание», Новые планы, решения и итоги',
    canonicalHref: 'https://znanierussia.ru/management/council-meetings',
  },
  '/news': {
    title: 'Новости Российского общества «Знание»',
    description: 'Новости общества «Знание», анонсы',
    canonicalHref: 'https://znanierussia.ru/news',
  },
  '/purchases': {
    title: 'Закупки Российского общества «Знание»',
    description:
      'Закупки, активные закупки, архивные закупки, положение о закупочной деятельности',
    canonicalHref: 'https://znanierussia.ru/purchases',
  },
  '/award-vote/2021/project': {
    title:
      'Проекты номинированные на Премию «Знание» 2021 - Российское Общество «Знание»',
    description:
      'Премия «Знание» 2021, Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://znanierussia.ru/award-vote/2021/project',
  },
  '/award-vote/2021/speaker': {
    title:
      'Просветители номинированные на Премию «Знание» 2021 - Российское Общество «Знание»',
    description:
      'Премия «Знание» 2021, Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://znanierussia.ru/award-vote/2021/speaker',
  },
  '/award-vote/2021/company': {
    title:
      'Компании номинированные на Премию «Знание» 2021 - Российское Общество «Знание»',
    description:
      'Премия «Знание» 2021, Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://znanierussia.ru/award-vote/2021/company',
  },
  '/award-vote/2022/project': {
    title:
      'Проекты номинированные на Премию «Знание» 2022 - Российское Общество «Знание»',
    description:
      'Премия «Знание» 2022, Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://znanierussia.ru/award-vote/2022/project',
  },
  '/award-vote/2022/speaker': {
    title:
      'Просветители номинированные на Премию «Знание» 2022 - Российское Общество «Знание»',
    description:
      'Премия «Знание» 2022, Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://znanierussia.ru/award-vote/2022/speaker',
  },
  '/award-vote/2022/company': {
    title:
      'Компании номинированные на Премию «Знание» 2022 - Российское Общество «Знание»',
    description:
      'Премия «Знание» 2022, Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://znanierussia.ru/award-vote/2022/company',
  },
  '/ligalektorov/winners': {
    title: 'Победители сезонов Лиги Лекторов - Российское Общество «Знание»',
    description: 'Победители сезонов конкурса «Лига Лекторов»',
    image: '/img/share/ligalektorov.jpg',
    canonicalHref: 'https://znanierussia.ru/ligalektorov',
  },
  '/projects': {
    title: 'Проекты - Российское Общество «Знание»',
    canonicalHref: 'https://znanierussia.ru/projects',
    description:
      'Все проекты от Российского общества "Знание" в одном месте. Заходите и регистрируйтесь на понравившееся вам мероприятие бесплатно!',
  },
  '/become-speaker': {
    title: 'Стать лектором Российского Общества “Знание” - онлайн регистрация',
    canonicalHref: 'https://znanierussia.ru/become-speaker',
    description:
      'Регистрируйтесь и подавайте заявку, чтобы стать лектором Российского общества "Знание". Стать лектором может каждый абсолютно бесплатно!',
  },
  '/become-member': {
    title: 'Стать членом Российского общества «Знание» - онлайн регистрация',
    canonicalHref: 'https://znanierussia.ru/become-member',
    description:
      'Регистрируйтесь и подайте заявку, чтобы стать членом  Российского общества "Знание".',
  },
  // TODO: эта мета должна приходить с бэка
  // не забыть при полной реализации подборок
  '/cinema/collections/new': {
    title: 'Новые знания в одной подборке от Российского Общества «Знание»',
    description:
      'В подборке Новое мы собрали для вас свежий контент на разные темы от ведущих лекторов',
  },
  '/cinema/collections/recommendations': {
    title: 'Рекомендованные знания в подборке от Российского Общества «Знание»',
    description:
      'В подборке мы собрали рекомендуемый нами контент для просвещения',
  },
  '/cinema/collections/popular': {
    title: 'Популярные знания в подборке от Российского Общества «Знание»',
    description:
      'В подборке Популярное собран самый просматриваемый контент от наших пользователей и лекторов',
  },
  '/speakers': {
    title: 'Лекторы Российского Общества «Знание»',
    canonicalHref: 'https://znanierussia.ru/speakers',
  },
  '/cinema': {
    title: 'Онлайн-кинотеатр «Знание»',
    description:
      'Тысячи фильмов, лекций, марафонов, интервью с участием именитых лекторов, учёных и мировых политиков.',
    canonicalHref: 'https://znanierussia.ru/cinema',
    image: '/img/share/cinema.jpeg',
  },
};

export const metaDataCookieName = 'use_server_metadata';
